import { cn } from "@/lib/utils";

interface PageTitleHeaderProps {
  title: string;
  subtitle?: string;
  className?: string;
  titleClassName?: string;
  subtitleClassName?: string;
}

export function PageTitleHeader({
  title,
  subtitle,
  className,
  titleClassName,
  subtitleClassName,
}: PageTitleHeaderProps) {
  return (
    <section
      className={cn(
        // min-h, never a fixed h: the band must grow when the title or subtitle
        // wraps to more lines, which it does at narrow widths and in es-US.
        // A fixed height plus overflow-hidden silently truncates the copy.
        "relative !z-[10] py-16  px-4 md:px-16 lg:px-20 pt-24  shadow-customDark rounded-bl-[40px] rounded-br-[40px] font-outfit min-h-[270px] overflow-hidden",
        "before:absolute before:inset-0 before:bg-[url('/images/title-header.png')] before:bg-cover before:opacity-30 before:z-0",
        className
      )}
    >
      {/* Foreground content */}
      <div className="relative z-10 mx-auto text-center">
        <h1
          className={cn(
            "text-3xl md:text-5xl font-medium text-yellow-500 mb-3",
            titleClassName
          )}
        >
          {title}
        </h1>
        {subtitle && (
          <p
            className={cn("text-white font-thin md:text-lg", subtitleClassName)}
          >
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
